
export const colors = {
  bgColors:["#fa33720d", "#fba12c0d", "#81dc910d", "#2555ef0d"],
  textColors: ["#FA3372", "#FBA12C", "#81DC91", "#2555EF"],
}